import categoryService from "../../../services/ticketService/categoryService";
import { useQuery } from "@tanstack/react-query";
import { CategoryInterface } from "../../../models/TicketModule/Category";
import { CACHE_KEY_CATEGORIES } from "../../../utils/constants";

const useCategory = (page: number, pageSize: number) =>
  useQuery<CategoryInterface[], Error>({
    queryKey: [
      CACHE_KEY_CATEGORIES,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => categoryService.GetAll(page, pageSize),
    initialData: [],
  });

export default useCategory;
